module.exports = __webpack_public_path__ + "img/MintPool_img1.fbc6c6a4.png";